export default "__VITE_ASSET__MuUXu7$YWchH5UugN6rj$A__"